<template>
  <question-group-component :group="group" v-for="group in groups"/>
</template>

<script lang="ts" setup>
import {onBeforeUnmount, provide} from 'vue';
import QualityMentoringForm from '../models/QualityMentoringForm';
const form = QualityMentoringForm.getInstance();
import { useRoute } from 'vue-router';
import QuestionGroupComponent from "./QuestionGroupComponent.vue";

const props = defineProps({
  id: Number,
})

let groups = form.getGroups(props.id);

onBeforeUnmount(() => {
  if(useRoute().params.id == props.id.toString()) {
    delete form.submission['root'];
  }
});
</script>
